import { render, staticRenderFns } from "./CollaboratorPanel.vue?vue&type=template&id=06a0c0c1&scoped=true"
import script from "./CollaboratorPanel.vue?vue&type=script&lang=js"
export * from "./CollaboratorPanel.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorPanel.vue?vue&type=style&index=0&id=06a0c0c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a0c0c1",
  null
  
)

export default component.exports